import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * Reusable checkbox form control.
 * Emits checked state changes via checkedChange output; supports disabled state.
 */
@Component({
  selector: 'app-form-checkbox',
  standalone: true,
  imports: [],
  templateUrl: './form-checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormCheckboxComponent {
  checked = input<boolean>(false);
  disabled = input<boolean>(false);

  checkedChange = output<boolean>();

  /**
   * Handles checkbox click: toggles checked state and emits new value when not disabled.
   */
  handleClick(): void {
    if (!this.disabled()) {
      this.checkedChange.emit(!this.checked());
    }
  }
}
